import { DataGridPremium, GridColDef, GridRowParams, useGridApiRef } from '@mui/x-data-grid-premium';
import { Status, useFetch } from '../../hooks/useFetch';
import {  useMemo } from 'react';
import dayjs from 'dayjs'
import { useLocation } from 'react-router-dom';
import { ReactComponent as EditIcon } from '../../icons/edit.svg';
import { IconButton, SvgIcon } from '@mui/material';
import { PREMMEALLIST } from '../../common/paths';
// import FlightDetails from './FlightDetails';

export interface IPremMealListGrid {
    dateFrom?: string;
    dateTo?: string;
}

function PremMealListGrid(props : IPremMealListGrid) {
    const apiRef = useGridApiRef();
    const location = useLocation();
    const { status, data = [] } = useFetch<Array<any>>(`/api/premmeal/from/${props.dateFrom}/to/${props.dateTo}`);
    
    const rowId = (row : any) => {
        return row.Id;
    }
    const rows = useMemo(() => {
        const result = data?.map(o => { return {
            ...o,
            id: rowId(o),
            Date: dayjs(o.depDate).format('YYYY-MM-DD'),
            Time: dayjs(o.depDate).format('HH:mm')
        }}) ?? [];
        return result.sort((a,b) => a.DepDate < b.DepDate ? -1 : 1);
    }, [data]);

    const navigateTo = (row : any) => {
        let gridState = apiRef.current.exportState();
        localStorage.setItem(`GRID_${location.pathname}`, JSON.stringify(gridState));
        window.open(`/${PREMMEALLIST}/${encodeURIComponent(row.Id)}`, '_blank');
    }

    const columns: GridColDef[] = [
        {
            field: "action",
            headerName: "",
            sortable: false,
            width:55,
            renderCell: ({ row }: Partial<GridRowParams>) =>
              (!row.Leg ? 
                  <IconButton color='primary' onClick={() => navigateTo(row)}>
                      <SvgIcon component={EditIcon} inheritViewBox />
                  </IconButton> : null),
            filterable: false
        },
        { field: 'Date', headerName: 'Date', minWidth: 120 },
        { field: 'Time', headerName: 'Time UTC', minWidth: 120 },
        { field: 'flightNumber', headerName: 'Flight no.', minWidth: 100 },
        { field: 'dep', headerName: 'Dep', minWidth: 80 },
        { field: 'dest', headerName: 'Dest', minWidth: 80 },
        { field: 'aircraft', headerName: 'Aircraft', minWidth: 80 },
        { field: 'haulType', headerName: 'Haul Type', minWidth: 160 },
        { field: 'direction', headerName: 'Direction', minWidth: 160 },
    ];

    return (
    <>
        <DataGridPremium
            apiRef={apiRef}
            autoHeight
            rows={rows}
            columns={columns}
            editMode='row'
            isCellEditable={(o) => false}
            rowSelection={true}
            getRowClassName={(params) => { return params.indexRelativeToCurrentPage % 2 === 1 ? `tui-grid-alternate-row` : ''}}
            pagination
            loading={status === Status.Fetching || status === Status.Idle}
            // onRowClick={(params) => {setCurrentFlight(params.row); setShowDetails(true)}}
        />
        {/* { currentFlight && <FlightDetails open={showDetails} flight={currentFlight} cancelAction={() => {setShowDetails(false);}} />} */}
    </>
        
    );
}

export default PremMealListGrid;